var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiners = function SvgDiners(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.997 15.75H22c.955.008 1.74-.773 1.751-1.746V2.006a1.789 1.789 0 00-.52-1.25A1.72 1.72 0 0021.997.25H2.001A1.718 1.718 0 00.77.757c-.33.33-.517.779-.521 1.247v11.99c.004.47.191.92.52 1.25.329.328.771.51 1.233.506h19.994zm0 .5h-.002.002z",
    strokeOpacity: 0.2,
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.002 2.052v-.016h4v.016a6 6 0 010 11.968v.016h-4v-.016a6 6 0 010-11.968z",
    fill: "#0165AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.602 11.428a3.6 3.6 0 000-6.784v6.784zm-2.4-6.784a3.6 3.6 0 000 6.784V4.644zm1.2 8.592a5.2 5.2 0 110-10.4 5.2 5.2 0 010 10.4z",
    fill: "#FFF"
  }))));
};
export default SvgDiners;